import React, { useEffect, useState, useMemo, useRef } from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_TablePagination,
} from 'material-react-table';
import { Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import * as moment from "moment";
import axios from "../axios";
import { Button } from "bootstrap";
import { AddDoctorDialog } from "./Dialogues/AddDoctorDialog";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { registerLicense } from "@syncfusion/ej2-base";

registerLicense("ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ==");

const DoctorsList = (props) => {
  const darkTheme = createTheme({
    palette: {
      mode: 'light'
    },
  });

  // State variables
  const [initialRender, setIntialRender] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [prevPageIndex, setPrevPageIndex] = useState(1);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]); // Store all fetched data
  const [pageSize, setPageSize] = useState(50);
  
  // Date filter states
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(1, "month").toDate(),
    endDate: moment().toDate(),
  });
  const [dates1, setDates1] = useState("");
  const [dates2, setDates2] = useState("");
  const [selectedOption, setSelectedOption] = useState("1month");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dateRangePickerRef = useRef(null);
 

  const handleFilterChange = (args) => {
    setColumnFilters(args.currentFilterObject);
  };

  // const handleSortChange = (args) => {
  //   const { currentSortObject } = args;
  //   setSortField(currentSortObject[0]?.id || '');
  //   setSorting(currentSortObject);
  // };
  console.log(sorting);

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  // Memoized columns
  // const columns = useMemo(() => [
    const columns = useMemo(
      () => [
        {
          accessorKey: 'firstname', //access nested data with dot notation
          header: 'Name',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '200',
          enableColumnFilterModes: false,
          Cell: ({ cell }) => {
            const loginId = cell.row.original.loginId; // Access the loginId from the row data
            return (
              <NavLink
                to={`/doctorDetails/${loginId}`} // Pass the loginId as a parameter in the URL
                className="table__row__item"
                target="_blank"
              >
                {cell.getValue() || '-'}
              </NavLink>
            );
          },
        },
        {
          accessorKey: 'qualifications',
          header: 'Qualifications',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '180',
          enableColumnFilter: false,
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'hospitals', //normal accessorKey
          header: 'Hospitals',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '180',
          enableColumnFilter: false,
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'contact',
          header: 'Mobile Number',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '200',
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'loginId',
          header: 'loginId',
          enableSorting: false,
          // columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
          size: '250',
          enableColumnFilterModes: false,
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          // accessorKey: 'assessmentCount',
          accessorKey: 'total_assessments',
          header: 'Total Assessments',
          // sortingFn: 'datetime', //use the built-in datetime sorting function instead of the default alphanumeric sorting function
          enableSorting: true,
          enableFiltering: false,
          enableColumnFilterModes: false,
          size: '230',
          Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
          accessorKey: 'createdOn',
          header: 'Created On',
          enableSorting: true,
          enableFiltering: false,
          enableColumnFilterModes: false,
          size: '200',
          Cell: ({ cell }) => {
            const value = cell.getValue();
            if (!value) return '-';
            // Format the date if needed
            const date = new Date(value);
            return date.toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric' 
            });
          },
        },
        // {
        //   accessorKey: 'patientId',
        //   header: 'Patient ID',
        //   enableSorting: false,
        //   columnFilterModeOptions: ['contains', 'startsWith', 'equals'],
        //   Cell: ({ cell }) => (
        //     <NavLink
        //       // to={`/patient/${cell.getValue()}/${cell.getValue()}`}
        //       // to={`/user/${cell.getValue()}`} // Adjust the link structure as per your routing
        //       className="table__row__item"
        //       target="_blank"
        //       to={`patient/${cell.row.original.userId}/${cell.getValue()}`}
        //     >
        //       {cell.getValue()}
        //     </NavLink>
        //   ),
        // },
      ],
      [],
    );

  // Material React Table hook
  const table = useMaterialReactTable({
    columns,
  
    muiPaginationProps: {
      showRowsPerPage: true,
      rowsPerPageOptions: [5, 20, 50, 100],
      showFirstButton: false,
      showLastButton: false,
    },
  
    muiTableProps: {
      sx: {
        borderCollapse: 'collapse', 
        '& td': {
          border: 'none',
          fontSize: '14px',
        },  
        '& th': {
          borderRight: '2px solid #a9a9a9',
          // borderLeft: '1px solid #606060',
          // margin:'2px 0 2px 0'
        },
      },
    },
    muiSkeletonProps: {
      animation: 'wave',
    },
    muiTableHeadCellProps: {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '14px',
        backgroundColor: "#fdfaf0",
        minHeight: '40px',
        borderRight: '1px solid #000',
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: '12px',
      },
    },
    muiTopToolbarProps:{
      sx:{
        boxSizing:"12px",
        fontSize:"14px"
      }
    },
    muiToolbarAlertBannerProps: isError
      ? {
          color: 'error', 
          children: 'Error loading data',
        }
      : undefined,
    muiTableContainerProps: { sx: { maxHeight: '600px' } },
    data,
    manualFiltering: true,
    manualSorting: true,
    enableGlobalFilter: false,
    enableSortingRemoval: true,
    enableDensityToggle: true,
    manualGrouping: true,
    pageSize: pageSize,
    manualPagination: false, // Changed to false for client-side pagination
    enableFilterMatchHighlighting: false,
    columnFilterDisplayMode: 'popover',
    enableColumnFilterModes: true,
    enableFacetedValues: true,
    enableFilters: true,
    sorting: sorting,
    onSortingChange: setSorting,
    enableColumnOrdering: true,
    enableColumnResizing: true, 
  
  
    // initialState: {showColumnFilters: true, pagination: { pageSize: 50, pageIndex: 1 } },
  
    renderBottomToolbar: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '10px',
        
        }}
      >
        <MRT_TablePagination table={table} />
      </Box>
    ),
    
    
    isMultiSortEvent: () => false,
   
    onColumnFiltersChange: setColumnFilters,
    // onColumnFiltersChange: handleFilterChange,
  
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
  });

  const queryParams = {
    ...columnFilters.reduce((params, filter) => {
      if (filter.id === 'contact') {
        params['mobileNumber'] = filter.value;
      } else if (filter.id === 'loginId') {
        params['userId'] = filter.value;
      } else{
        params[filter.id] = filter.value;
      }
      return params;
    }, {}),
  };

  const sortingParams = (sorting) => {
    const params = {};
  
    // Check if sorting information is provided
    if (sorting && sorting.length > 0) {
      const sortInfo = sorting[0];
      params['sort_field'] = sortInfo.id;
      params['sort_type'] = sortInfo.desc ? 'desc' : 'asc';
    }
  
    return params;
  };
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
      
      const startDateFormatted = encodeURIComponent(`${startDate1} 00:00:00`);
      const endDateFormatted = encodeURIComponent(`${endDate1} 23:59:59`);
      
      const response = await axios.get(
        `/getDoctors?created_on_start=${startDateFormatted}&created_on_end=${endDateFormatted}&page_size=10000&page_number=1`,
        {
          headers: {
            accessToken: localStorage.accessToken
          }
        }
      );

      if (response.data.message) {
        setAllData([]);
        setData([]);
        setRowCount(0)
      } else {
        const fetchedData = response.data.data.users;
        setAllData(fetchedData); // Store all data
        setData(fetchedData); // Display all data (Material React Table will handle pagination)
        setRowCount(response.data.doctors_count || response.data.complete_doctors_count);
        
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (initialRender) {
      setIntialRender(false);
      const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
      setDates1(startDate1);
      setDates2(endDate1);
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (!initialRender) {
      const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
      setDates1(startDate1);
      setDates2(endDate1);
      setPagination({ ...pagination, pageIndex: 0 });
      setPageNumber(1);
      fetchData();
    }
  }, [dateRange]);

  // Removed pagination and pageSize useEffect hooks - now handled on frontend

  useEffect(() => {
    if (!initialRender && allData.length > 0) {
      fetchSortedData();
    }
  }, [sorting]);

  useEffect(() => {
    if (!initialRender && allData.length > 0) {
      fetchFilteredData();
    }
  }, [columnFilters]);

  const fetchPaginatedData = async () => {
    // No longer needed - pagination handled on frontend
  };

  const fetchPageSizeData = async () => {
    // No longer needed - page size handled on frontend
  };

  const fetchSortedData = async () => {
    setIsRefetching(true);
    try {
      const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
      
      const startDateFormatted = encodeURIComponent(`${startDate1} 00:00:00`);
      const endDateFormatted = encodeURIComponent(`${endDate1} 23:59:59`);
      
      const response = await axios.get(`/getDoctors?created_on_start=${startDateFormatted}&created_on_end=${endDateFormatted}&page_size=10000&page_number=1`, {
        headers: { accessToken: localStorage.accessToken },
        params: {
          ...queryParams,
          ...sortingParams(sorting),
        }
      });
  
      if (response.data.message) {
        setAllData([]);
        setData([]);
        setRowCount(0);
      } else {
        const fetchedData = response.data.data.users;
        setAllData(fetchedData);
        setData(fetchedData);
        setRowCount(response.data.complete_doctors_count);
      }
  
      setIsError(false);
  
    } catch (error) {
      console.log("error", error);
      setIsError(true);
    } finally {
      setIsRefetching(false);
    }
  };
  

  const fetchFilteredData = async () => {
    setIsRefetching(true);
    try {
      const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
      
      const startDateFormatted = encodeURIComponent(`${startDate1} 00:00:00`);
      const endDateFormatted = encodeURIComponent(`${endDate1} 23:59:59`);
      
      const response = await axios.get(`/getDoctors?created_on_start=${startDateFormatted}&created_on_end=${endDateFormatted}&page_size=10000&page_number=1`, {
        headers: { accessToken: localStorage.accessToken },
        params: {
          ...queryParams,
          ...sortingParams(sorting),
        },
      });
  
      if (response.data.message) {
        setAllData([]);
        setData([]);
        setRowCount(0)
      } else {
        const fetchedData = response.data.data.users;
        setAllData(fetchedData);
        setData(fetchedData);
        setRowCount(response.data.complete_doctors_count);
      }
      setIsError(false);
      setIsRefetching(false);
    } catch (error) {
      console.log("error", error);
      setIsError(true);
      setIsRefetching(false);
    }
  };

  const fetchNextDoctors = async (ind) => {
    // No longer needed - pagination handled on frontend
  };

  const fetchPreviousDoctors = async (ind) => {
    // No longer needed - pagination handled on frontend
  };

  // Export to CSV function
  const handleExportToCSV = async () => {
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }

    try {
      // Show loading state
      setIsLoading(true);

      // Fetch all data without pagination
      const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
      
      const startDateFormatted = encodeURIComponent(`${startDate1} 00:00:00`);
      const endDateFormatted = encodeURIComponent(`${endDate1} 23:59:59`);
      
      const response = await axios.get(
        `/getDoctors?created_on_start=${startDateFormatted}&created_on_end=${endDateFormatted}&page_size=10000&page_number=1`,
        {
          headers: {
            accessToken: localStorage.accessToken
          }
        }
      );

      const allData = response.data.data?.users || [];
      
      if (allData.length === 0) {
        alert('No data to export');
        setIsLoading(false);
        return;
      }

      // Define CSV headers
      const headers = ['Name', 'Qualifications', 'Hospitals', 'Mobile Number', 'loginId', 'Total Assessments', 'Created On'];
      
      // Convert data to CSV rows
      const csvRows = allData.map(row => {
        // Format the date without commas
        let formattedDate = '-';
        if (row.createdOn) {
          const date = new Date(row.createdOn);
          // Use YYYY-MM-DD format to avoid comma issues in CSV
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          formattedDate = `${year}-${month}-${day}`;
        }
        
        return [
          row.firstname || '-',
          row.qualifications || '-',
          row.hospitals || '-',
          `'${row.contact || '-'}`, // Add single quote prefix to preserve as text
          row.loginId || '-',
          row.total_assessments || row.assessmentCount || '-',
          formattedDate
        ];
      });

      // Combine headers and rows
      const csvContent = [
        headers.join(','),
        ...csvRows.map(row => row.join(','))
      ].join('\n');

      // Create filename with date range
      const fileStartDate = moment(dateRange.startDate).format("YYYY-MM-DD");
      const fileEndDate = moment(dateRange.endDate).format("YYYY-MM-DD");
      const filename = `doctors_list_${fileStartDate}_to_${fileEndDate}.csv`;

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setIsLoading(false);
    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export data. Please try again.');
      setIsLoading(false);
    }
  };

  // Date filter handlers
  const handleDateChange = (args) => {
    if (args.value) {
      setDateRange({
        startDate: args.value[0],
        endDate: args.value[1],
      });
      setSelectedOption("");
      setShowDatePicker(false);
    }
  };

  const handleOptionChange = (e) => {
    const option = e.target.value;
    setSelectedOption(option);
    const today = new Date();
    let startDate, endDate;

    switch (option) {
      case "1week":
        startDate = moment(today).subtract(1, "week").toDate();
        endDate = today;
        break;
      case "1month":
        startDate = moment(today).subtract(1, "month").toDate();
        endDate = today;
        break;
      case "3months":
        startDate = moment(today).subtract(3, "months").toDate();
        endDate = today;
        break;
      case "6months":
        startDate = moment(today).subtract(6, "months").toDate();
        endDate = today;
        break;
      case "1year":
        startDate = moment(today).subtract(1, "year").toDate();
        endDate = today;
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }

    setDateRange({ startDate, endDate });
    setShowDatePicker(false);
  };

  return (
    <div className="dashboard">
     
      <div className="dashboard__content" style={{marginTop: '45px'}} >
      
      {/* Date Filter and Buttons Row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        {/* Date Filter Section */}
        <div className="dateSelection">
          <select 
            className="selectDate"
            id="duration"
            value={selectedOption} 
            onChange={handleOptionChange}
          >
            <option value="">Date Range</option>
            <option value="1week">1 Week</option>
            <option value="1month">1 Month</option>
            <option value="3months">3 Months</option>
            <option value="6months">6 Months</option>
            <option value="1year">1 Year</option>
            <option value="custom">Custom</option>
          </select>
          
          {showDatePicker && (
            <div className="dateRangePicker">
              <DateRangePickerComponent
                id="daterangepicker"
                placeholder="Select a range"
                change={handleDateChange}
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                showClearButton={false}
                format="yyyy-MM-dd"
                ref={dateRangePickerRef}
              />
            </div>
          )}
          
          <div className="dates-container">
            <p className="dates">{moment(dates1).format("DD-MM-YYYY")} </p>
            <p className="dates">to</p>
            <p className="dates">{moment(dates2).format("DD-MM-YYYY")} </p>
          </div>
        </div>

        {/* Buttons Section */}
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <button 
            className="addExportButton" 
            type="button" 
            onClick={handleExportToCSV}
            disabled={!data || data.length === 0}
          >
            Export CSV
          </button>
          <button className="addDoctorButton"  type="button" onClick={handleOpenDialog}>Add Doctor</button>
        </div>
      </div>
      
      <AddDoctorDialog open={isDialogOpen} onClose={handleCloseDialog} />
      
    <div>
    <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <MaterialReactTable table={table} pageSize={pagination.pageSize} />
      </ThemeProvider>  
    </div>

   
    </div>
    </div>
  );
};

export default DoctorsList;